import { ProductFullInfo } from '@shared/model/product';
import { MutateFormFields } from '../ui/modal-mutate-product/types';
import { useMemo } from 'react';
import { normalizeDatepickerValue } from '@shared/lib/utils/normalize-datepicker-value/normalize-datepicker-value';

export const useNormalizeInitialValues = (values?: ProductFullInfo, additionalInfo?: Partial<MutateFormFields>) => {
    return useMemo(() => {
        if (!values) {
            const result: MutateFormFields = {
                name: '',
                productInfoUrl: '',
                description: '',
                code: '',
                price: '',
                withoutPrice: false,
                place: '',
                textOrderFail: '',
                textOrderSuccess: '',
                active: 'true',
                type: [],
                catalogs: [],
                date: { value: '' },
                sort: 100,
                emailDomainRestricted: false,

                /* CRM */
                crmInterestCode: [],
                crmProductExternalId: [],
                crmNeedOpportunity: false,

                image: {
                    initialUploadedFiles: [],
                    addedUploadedFiles: [],
                    deletedUploadedFiles: [],
                    localFiles: [],
                    filesQueue: [],
                },
                files: {
                    initialUploadedFiles: [],
                    addedUploadedFiles: [],
                    deletedUploadedFiles: [],
                    localFiles: [],
                    filesQueue: [],
                },
                ...additionalInfo,
            };
            return result;
        }

        const initialUploadedImages = values.previewImages.map((file) => ({
            url: file.url,
            id: file.id,
            name: file.name,
            extension: file.meta.extension,
            size: file.meta.size,
        }));

        const initialUploadedFiles = values.files.map((file) => ({
            url: file.url,
            id: file.id,
            name: file.name,
            extension: file.meta.extension,
            size: file.meta.size,
        }));

        const crmInterestCode = values.crmInterest
            ? [
                  {
                      label: `${values.crmInterest.name}(${values.crmInterest.code})`,
                      value: String(values.crmInterest.code),
                  },
              ]
            : [];

        const crmProductExternalId = values.crmProduct
            ? [
                  {
                      label: `${values.crmProduct.externalId}: ${values.crmProduct.name}`,
                      value: String(values.crmProduct.externalId),
                  },
              ]
            : [];

        const result: MutateFormFields = {
            ...values,
            withoutPrice: values.isPriceUndefined,
            emailDomainRestricted: values.isEmailDomainRestricted,
            active: String(values.active),
            type: [
                {
                    label: values.type.name,
                    value: String(values.type.id),
                },
            ],

            /* CRM */
            crmInterestCode: crmInterestCode,
            crmProductExternalId: crmProductExternalId,
            crmNeedOpportunity: values.crmNeedOpportunity,

            price: String(Number(values.price)),
            catalogs:
                values.catalogs?.map((product) => ({
                    label: product.name,
                    value: String(product.id),
                })) || [],
            date: {
                value: normalizeDatepickerValue(values.startAt, values.endAt),
            },
            image: {
                initialUploadedFiles: initialUploadedImages,
                addedUploadedFiles: [],
                deletedUploadedFiles: [],
                localFiles: [],
                filesQueue: initialUploadedImages,
            },
            files: {
                initialUploadedFiles: initialUploadedFiles,
                addedUploadedFiles: [],
                deletedUploadedFiles: [],
                localFiles: [],
                filesQueue: initialUploadedFiles,
            },
            ...additionalInfo,
        };
        return result;
    }, [values, additionalInfo]);
};
